export default "__VITE_ASSET__BoTY5_SZ__"